import { Trans } from "@lingui/react/macro";
import React from "react";
import { TextStyle, TextStyleProps } from "@silversea-ssc/ui-components-react";

type Props = {
  textAlign: TextStyleProps["textAlign"];
  titleFontSize: TextStyleProps["fontSize"];
};

const SendQuoteSectionIntroText: React.FC<Props> = ({
  textAlign,
  titleFontSize = "medium"
}) => (
  <TextStyle fontSize={titleFontSize} textAlign={textAlign}>
    <Trans>
      By submitting this form you will receive your preliminary quote via email
      for two guests. You can always return to our website for more details or
      speak with one of our personal cruise experts, who will contact you
      shortly to answer any questions you may have about your voyage.
    </Trans>
  </TextStyle>
);
export default SendQuoteSectionIntroText;
